export { initChiefSlider, Slide, SlidesCarousel } from './core';

export { BuildDescription } from './item/BuildDescription';
export { LinkInNewPage } from './item/LinkInNewPage';
export { LinkOutSVG } from './item/LinkOutSVG';
export { RollUpClickableTitle } from './item/RollUpClickableTitle';
export { WrapBannerImageWithHref } from './item/WrapBannerImageWithHref';



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/index.jsx